import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    private showLoaderSubject = new BehaviorSubject<boolean>(false);
    private showLoaderTrans = new BehaviorSubject<boolean>(false);
    public showLoader$ = this.showLoaderSubject.asObservable();
    public showLoaderTrans$ = this.showLoaderTrans.asObservable();

    constructor(private titleService: Title) {
    }
    async show(n?: number) {
        this.showLoaderSubject.next(true);
        this.showLoaderTrans.next(n ? true : false);
        await function () {
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
            document.body.style.height = '100%';
        }
    }
    async hide() {
        await setTimeout(() => {
            this.showLoaderSubject.next(false);
            this.showLoaderTrans.next(false);
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
            document.body.style.height = '';
        }, 1000);
      //  }, 500);

    }
    getTitle() {
        return this.titleService.getTitle();
    }
}
